import router from '../router/router'

export default function createWebSocketPlugin(WS) {
  return store => {

    let pingInterval;

    WS.onopen = function () {

      store.commit({
        type: 'setWSConnectState',
        connect: true,
        error: false,
        ws: WS,
      });

      pingInterval = setInterval(function () {
        WS.send(JSON.stringify({
          event: "ping",
        }));
      }, 1000);

      console.log('открыл ')
    };

    WS.onclose = function (i) {

      store.commit({
        type: 'setWSConnectState',
        connect: false,
        error: true,
        ws: WS,
      });

      clearInterval(pingInterval);
      router.push({path: '/login'});
      console.log('закрыл ', i)
    };

    WS.onmessage = function (msg) {
      let data = JSON.parse(msg.data);

      if (data.event === "userState") {
        store.commit({
          type: 'setUser',
          user: data.user,
        });
      }

      if (data.event === "getAllLogsByDate") {
        store.commit({
          type: 'setLogs',
          logs: data.logs,
        });
      }

      if (data.event === "newCourier" || data.event === "removeCourier") {
        WS.send(JSON.stringify({
          event: 'getAllUsers',
        }))
      }

      if (data.event === "getAllUsers") {
        store.commit({
          type: 'setUsers',
          users: data.users,
        });
      }

      if (data.event === "getOrder") {

        store.commit({
          type: 'setOrder',
          order: data.order,
          clientFullPrice: data.client_full_price,
          clientPaid: data.client_paid,
          city: data.city,
          region: data.region,
          items: data.items,
          allowDeliveryDatesAndIntervals: data.dates,
          searchField: data.data,
        });

        store.commit({
          type: 'setPendingOrders',
          pending: false,
        });
      }

      if (data.event === "calculateClientItemsPrice") {
        store.commit({
          type: 'setClientPaid',
          clientFullPrice: data.client_full_price,
          clientPaid: data.client_paid,
        });
      }

      if (data.event === "Error") {
        if (data.data === 'getOrder') {
          store.commit({
            type: 'setPendingOrders',
            pending: false,
          });
        }

        store.commit({
          type: 'setError',
          errorMethod: data.data,
          title: 'Ошибка',
          error: data.error,
          show: true,
        });
      }

      if (data.event === "SussesSetStatus") {

        store.commit({
          type: 'setOrder',
          order: null,
        });

        store.commit({
          type: 'setMessage',
          msgMethod: data.event,
          title: 'Успех: ',
          msg: 'Статус успешно установлен',
          show: true,
          data: data.data,
        });
      }
    };
  };
}



// WEBPACK FOOTER //
// ./src/store/ws.js